import { ALL_AVAILABLE_ADD_ONS } from 'pricing-pages-lib/constants/AllAvailableAddOns';
import { getAddonRestrictionDetails } from '../constants/addonsAndServices/AddonsRestrictionMap';
import { hasPricingAndPurchasingSucceededSelector } from './LoadingStateSelectors';
import { currentProductVersionSelector, currentSkuIdForProductSelector, productSelector } from './ProductsSelectors';
export const eligibleAddOnSkuIdsSelector = (state, {
  selectedProductConfigurations
}) => {
  if (!hasPricingAndPurchasingSucceededSelector(state)) return [];
  return ALL_AVAILABLE_ADD_ONS.filter(apiName => {
    const product = productSelector(state, {
      apiName
    });
    if (!product) return false;
    const {
      id: productId
    } = product;
    const productVersion = currentProductVersionSelector(state, {
      productId
    });
    if (!productVersion) return false;
    const {
      versionNumber
    } = productVersion;
    const restrictionDetails = getAddonRestrictionDetails({
      apiName,
      versionNumber
    });

    // if there is no entry in the AddOnsRestrictionMap for a given add-on, return false
    // this prevents add-ons from showing up as available to purchase by themselves before a hub is selected
    if (!restrictionDetails) return false;
    return !restrictionDetails.isRestricted(state, {
      productConfigurations: selectedProductConfigurations
    });
  }).map(apiName => currentSkuIdForProductSelector(state, {
    apiName
  }));
};